export { wrapPageElement } from "./src/wrapPageElement"

export const registerServiceWorker = () => true

export const onClientEntry = () => {
  registerServiceWorker()
}
